Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isAndroid = isAndroid;
exports.isChromeDebugger = isChromeDebugger;
exports.isJest = isJest;
exports.isReducedMotion = isReducedMotion;
exports.isWeb = isWeb;
exports.isWindowAvailable = isWindowAvailable;
exports.nativeShouldBeMock = nativeShouldBeMock;
exports.shouldBeUseWeb = shouldBeUseWeb;
var _reactNative = require("react-native");
function isJest() {
    return !!process.env.JEST_WORKER_ID;
}
function isChromeDebugger() {
    return !global.nativeCallSyncHook || !!global.__REMOTEDEV__;
}
function isWeb() {
    return _reactNative.Platform.OS === "web";
}
function isAndroid() {
    return _reactNative.Platform.OS === "android";
}
function isWindows() {
    return _reactNative.Platform.OS === "windows";
}
function shouldBeUseWeb() {
    return isJest() || isChromeDebugger() || isWeb() || isWindows();
}
function nativeShouldBeMock() {
    return isJest() || isChromeDebugger() || isWindows();
}
function isWindowAvailable() {
    return typeof window !== "undefined";
}
function isReducedMotion() {
    var _REANIMATED_IS_REDUCE;
    return isWeb() ? isWindowAvailable() ? !window.matchMedia("(prefers-reduced-motion: no-preference)").matches : false : (_REANIMATED_IS_REDUCE = global._REANIMATED_IS_REDUCED_MOTION) != null ? _REANIMATED_IS_REDUCE : false;
}
